/* Ladnini — mobile filter drawer toggle for sections/product-grid.liquid.
   Opens/closes the off-canvas ".ladnini-filter-drawer" added around
   {% render 'ladnini-filter-sidebar' %} (see ladnini-product-grid-layout.css
   for the show/hide CSS, gated by the "ladnini-filter-drawer-open" class
   this adds to <html>).

   Reparenting: "position: fixed" is only guaranteed to sit relative to
   the real browser viewport if NO ancestor has a transform / filter /
   perspective / will-change:transform — any of those makes that ancestor
   the element's containing block instead, and the drawer ends up
   positioned relative to THAT box (which can be narrower than, or
   offset from, the real screen — exactly the "everything is shifted
   right, text cut off on the edge" symptom). Rather than track down
   which ancestor does this (Shopify's own theme-editor preview frame is
   a common culprit, but a theme's own page-transition wrapper can do it
   too), this moves the backdrop + drawer to be direct children of
   <body> whenever the mobile breakpoint is active, so they always sit
   relative to the true viewport regardless of what wraps the rest of
   the page. On desktop they're moved back to their original spot inside
   .ladnini-pg-layout, where the grid CSS needs them as a direct child
   to lay out the sidebar column. */
(function () {
  var MOBILE_QUERY = '(max-width: 989px)';

  function initFilterDrawer(layout) {
    var toggle = layout.querySelector('[data-ladnini-filter-toggle]');
    var drawer = layout.querySelector('[data-ladnini-filter-drawer]');
    var backdrop = layout.querySelector('[data-ladnini-filter-backdrop]');
    var closeBtn = layout.querySelector('[data-ladnini-filter-close]');
    if (!toggle || !drawer) return;

    // Remember where these two lived originally so they can go back on desktop.
    var originalParent = layout;
    var backdropNextSibling = backdrop ? backdrop.nextSibling : null;
    var drawerNextSibling = drawer.nextSibling;
    var isReparented = false;

    function reparentToBody() {
      if (isReparented) return;
      if (backdrop) document.body.appendChild(backdrop);
      document.body.appendChild(drawer);
      isReparented = true;
    }

    function restoreToLayout() {
      if (!isReparented) return;
      if (backdrop) originalParent.insertBefore(backdrop, backdropNextSibling);
      originalParent.insertBefore(drawer, drawerNextSibling);
      isReparented = false;
    }

    function syncParent(mql) {
      if (mql.matches) {
        reparentToBody();
      } else {
        closeDrawer();
        restoreToLayout();
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        closeDrawer();
      }
    }

    function openDrawer() {
      layout.classList.add('is-filters-open');
      document.documentElement.classList.add('ladnini-filter-drawer-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', onKeydown);
    }

    function closeDrawer() {
      layout.classList.remove('is-filters-open');
      document.documentElement.classList.remove('ladnini-filter-drawer-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
    }

    toggle.addEventListener('click', function () {
      if (layout.classList.contains('is-filters-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    var mql = window.matchMedia(MOBILE_QUERY);
    syncParent(mql);
    if (mql.addEventListener) {
      mql.addEventListener('change', syncParent);
    } else if (mql.addListener) {
      // Safari < 14
      mql.addListener(syncParent);
    }
  }

  document.querySelectorAll('.ladnini-pg-layout').forEach(initFilterDrawer);
})();